enum Role {
  Owner = 'Owner',
  Developer = 'Developer',
  Administrator = 'Administrator',
  ClosedBeta = 'ClosedBeta',
  Visitor = 'Visitor',
}

export default Role;
